



















































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { processServe, userManagementServe } from '@/api/installServer';
import shuttleOldBox from '@/components/shuttleBox/shuttleOldBox.vue';
import ShuttleOABox from '@/components/shuttleOABox/shuttleOABox.vue';

@Component({
  components: { shuttleOldBox, ShuttleOABox },
})
export default class BasicSetting extends Vue {
  @Prop() private formData: any;
  showIcon = false; // 图标窗口是否显示
  openOneGroup = false; // 点击所在分组输入框 打开分组项
  showCreateGroup = false; // 点击新建分组显示新建内容窗口

  private iconColor: any = ['#008bff', '#0ac756', '#fa953d', '#fe6533', '#FDA014'];

  private input_i: any; // 获取所在分组下拉图标

  private one_create: any; // 分组新建与选择窗口容器

  // 表单数据
  // private formData: any = {
  //   icon: '',
  //   name: '',
  //   groupName: '',
  //   desc: '',
  //   sponsor: '',
  //   admin: '',
  //   color: '',
  // };

  // 存放分组名称
  private group: any = ['出勤休假', '其他'];

  // 表单验证规则
  formRules: object = {
    icon: [{ required: true, message: '必填信息', trigger: 'blur' }], // 表单图标验证规则
    name: [{ required: true, message: '必填信息', trigger: 'blur' }], //
    group: [{ required: true, message: '必填信息', trigger: 'blur' }],
  };

  // 图标列表
  private iconList: any = [];

  adminTree: any;

  private created() {
    // console.log(this.formData);
    // console.log(document.body.clientWidth);
  }

  private mounted() {
    this.getGroup();
    this.getIconJson();

    this.getAdminTree();
    // this.changeIconColor(0, '#008bff');
    this.input_i = document.getElementById('input_i');

    document.addEventListener('click', e => {
      e.stopPropagation();
      const icon_list = document.getElementsByClassName('icon_box')[0];
      this.one_create = document.getElementsByClassName('group_box')[0];
      if (icon_list && !icon_list.contains(e.target as any)) {
        this.showIcon = false;
      }
      if (this.one_create && !this.one_create.contains(e.target as any) && this.input_i) {
        this.input_i.style.transform = 'rotate(0deg)';
        this.input_i.style.transition = '0.3s';
        this.openOneGroup = false;
        this.showCreateGroup = false;
      }
    });

    // console.log(this.allForm);
  }

  getGroup() {
    processServe
      .getProcessData({})
      .then((res: any) => {
        // console.log(res);
        this.group = res.data;
      })
      .catch((e: any) => {});
  }

  private destroyed() {
    document.removeEventListener('click', e => {
      e.stopPropagation();
    });
  }

  idToName(id: any) {
    let name: any = '';
    // console.log(this.adminTree);
    this.adminTree.forEach((admin: any) => {
      if (id === admin.id) {
        name = admin.name;
      }
    });
    return name;
  }

  formIdToName() {
    // console.log(this.formData.admin);
    this.formData.admin.forEach((item: any, index: any) => {
      // console.log(item);
      this.formData.admin[index].objName = this.idToName(item.objId);
    });
  }

  getAdminTree() {
    userManagementServe
      .sysAllUserList({
        size: 100,
        admin: true,
      })
      .then((res: any) => {
        this.adminTree = res.data.records;
        // console.log(this.adminTree);
        // this.formIdToName();
      })
      .catch((error: any) => {});
  }

  /**
   * @desc 获取icon列表
   */
  private getIconJson() {
    fetch('icon/iconfont.json').then(res => {
      res.json().then(r => {
        this.iconList = r.glyphs.map((icon: any) => ({
          name: icon.name,
          className: `icon${icon.font_class}`,
        }));
      });
    });
  }

  /**
   * @desc 打开可选图标窗口
   */
  OpenIconList(): void {
    this.showIcon = true;
  }

  /**
   * @desc 选中图标 显示到容器中
   */
  getIconName(icon: string) {
    this.formData.icon = icon;
    this.$forceUpdate();
  }

  /**
   * @desc 背景色选择
   */
  changeIconColor(index: number, itemColor: any) {
    const colorItem: any = document.getElementsByClassName('color_border')[index];
    const colorItems: any = document.querySelectorAll('.color_border');
    for (let i = 0; i < colorItems.length; i++) {
      const item = colorItems[i];
      item.style.borderColor = 'transparent';
    }
    colorItem.style.borderColor = itemColor;
    this.formData.themeColor = itemColor;
  }

  /**
   * @desc 点击打开选择分组下拉框
   */
  openGroup() {
    this.openOneGroup = true;
    this.input_i.style.transform = 'rotate(-180deg)';
    this.input_i.style.transition = '0.3s';
  }

  /**
   * @desc 分组下拉列表中点击选中某项
   */
  choiceOption(item: any) {
    this.formData.groupName = item.name;
    this.formData.groupId = item.id;
    this.openOneGroup = false;
    this.showCreateGroup = false;
  }

  /**
   * @desc 点击分组中新建分组  打开新建分组弹窗
   */
  openTwoCreate(): void {
    this.showCreateGroup = true;
  }

  /**
   * @desc 点击叉号取消 新建分组
   */
  // cancelButton(e: any) {
  //   e.stopPropagation();
  //   this.showCreateGroup = false;
  // }
  //
  // /**
  //  * @desc 点击对号完成 新建分组
  //  */
  // ensureButton(): void {
  //   const inputVal = (document.getElementsByClassName('create_group_input')[0] as HTMLInputElement).value;
  //   if (this.group.indexOf(inputVal) === -1) {
  //     this.group.unshift(inputVal);
  //     this.showCreateGroup = false;
  //     this.openOneGroup = false;
  //     this.formData.groupName = inputVal;
  //   } else {
  //     alert('分组已存在');
  //   }
  // }

  choseSponsor() {
    const shuttleBox = 'shuttleBox';
    const shuttleBoxComponent = this.$refs[shuttleBox];
    (shuttleBoxComponent as any).showDialog(this.formData.startAuthOrgMember);
  }

  choseAdmin() {
    const shuttleOABox = 'shuttleOABox';
    const shuttleOABoxComponent = this.$refs[shuttleOABox];
    (shuttleOABoxComponent as any).showDialog(this.formData.admin, '用户');
  }

  checkNodeData(data: any) {
    // console.log(data);
    this.formData.startAuthOrgMember = data;
  }

  checkOANodeData(data: any) {
    // console.log(data);
    this.formData.admin = data;
    const arr: any = [];
    data.forEach((item: any) => {
      arr.push(item.objId);
    });
    this.formData.editAuthStaffIds = arr.toString();
  }

  @Watch('formData', { deep: true })
  private setData() {
    // console.log(this.formData);
    const data = {
      formData: this.formData,
      type: 'basic',
    };
    this.$emit('setData', data);
  }
}
